<template>
  <div>
    <v-dialog v-model="WarningNotification" width="400px" persistent>
      <v-card color="white">
        <v-toolbar
          class="elevation-2 white--text"
          color="blueColorVariant9"
          dense
          >Alert Notification</v-toolbar
        >

        <div align="center" class="pt-3 fontsize25px">
          Motorist
          <span class="font-weight-bold blueColorVariant9--text">
            {{ this.$store.getters.get_motorist_name.user_name }}
          </span>
          has sent an alert message to his/her family and friends
        </div>
        <v-card-actions class="mt-16">
          <v-spacer />
          <v-btn @click="AlertDialogEmit(1)" small color="black" dark depressed
            >OK</v-btn
          >
        </v-card-actions>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
export default {
  props: {
    WarningNotification: Boolean,
  },
  data: () => ({}),
  methods: {
    AlertDialogEmit(Toggle) {
      this.$emit("clicked", Toggle);
    },
  },
};
</script>
